import { Box, styled, Typography } from "@mui/material";
import { ProcessingActivityReportReceipt, ProcessingActivityReportViewModel } from "./ProcessingActivityReport.types";
import SpanBox from "./SpanBox.tsx";
import { ProcessingActivityStatus } from "../processingActivity/processingActivities/ProcessingActivities.types.ts";
import { useState } from "react";
import ProcessingActivtyReportDialog from "./processingActivityReportDialog/ProcessingActivityReportDialog.tsx";
import ProcessingActivityReportReceiptDialog from "./processingActivityReportReceiptDialog/processingActivityReportReceiptDialog.tsx";

export const HeaderBox = styled("div")(({ theme }) => ({
    marginBottom: theme.spacing(3),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
}));

export const BodyTypography = styled("div")(({ theme }) => ({
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.primary.dark,
}));

export const HeaderBodyTypography = styled(Typography)(({ theme, fontSize }) => ({
    fontSize: theme.typography.pxToRem(fontSize ? Number.parseInt(fontSize.toString()) : 13),
    color: theme.palette.primary.dark,
    fontWeight: "bold",
    display: "inline",
    marginRight: theme.spacing(0.5),
}));

export const DateBox = styled("div")(({ theme }) => ({
    width: theme.spacing(32),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
}));

export const ItalicHeader = styled("div")(({ theme }) => ({
    fontStyle: "italic",
    display: "inline-block",
}));

export const TextBoxWrapper = styled("div")(({ theme }) => ({
    "& > *": {
        marginTop: `${theme.spacing(1)} !important`,
    },
}));

export type ReportDataBasis = {
    dataProcessors: Array<string>;
    dataControllers: Array<string>;
    disclosures: Array<string>;
    jointDataControllers: Array<string>;
    sources: Array<string>;
};

export const getDataBasis = (translateString: any, data?: ReportDataBasis) => {
    const hasNoDataBasis =
        data &&
        data.dataProcessors.length === 0 &&
        data.disclosures.length === 0 &&
        data.jointDataControllers.length === 0 &&
        data.sources.length === 0 &&
        data.dataControllers.length === 0;

    return (
        <Box marginTop={hasNoDataBasis ? 0 : 0.75} marginBottom={3}>
            {data && data.dataProcessors.length > 0 && (
                <Box marginBottom={1}>
                    <BodyTypography>
                        <ItalicHeader>{translateString("dataProcessors") + ": "}</ItalicHeader>
                        <SpanBox> {data?.dataProcessors.join(", ")}</SpanBox>
                    </BodyTypography>
                </Box>
            )}

            {data && data.disclosures.length > 0 && (
                <Box marginBottom={1}>
                    <BodyTypography>
                        <ItalicHeader>{translateString("disclosures") + ": "}</ItalicHeader>
                        <SpanBox> {data?.disclosures.join(", ")}</SpanBox>
                    </BodyTypography>
                </Box>
            )}

            {data && data.jointDataControllers.length > 0 && (
                <Box marginBottom={1}>
                    <BodyTypography>
                        <ItalicHeader>{translateString("jointDataControllers") + ": "}</ItalicHeader>
                        <SpanBox> {data?.jointDataControllers.join(", ")}</SpanBox>
                    </BodyTypography>
                </Box>
            )}

            {data && data.sources.length > 0 && (
                <Box marginBottom={1}>
                    <BodyTypography>
                        <ItalicHeader>{translateString("sources") + ": "}</ItalicHeader>
                        <SpanBox> {data?.sources.join(", ")}</SpanBox>
                    </BodyTypography>
                </Box>
            )}

            {data && data.dataControllers.length > 0 && (
                <Box marginBottom={1}>
                    <BodyTypography>
                        <ItalicHeader>{translateString("dataControllers") + ": "}</ItalicHeader>
                        <SpanBox> {data?.dataControllers.join(", ")}</SpanBox>
                    </BodyTypography>
                </Box>
            )}
        </Box>
    );
};

export interface IProcessingActivityReportProps {
    processingActivityName: string | undefined;
    processingActivityId: string | undefined;
    onDialogClose: () => void;
    showReportDialog: boolean;
    processingActivityStatus: ProcessingActivityStatus | undefined;
    onSubmitReport: () => void;
}

function ProcessingActivityReport(props: IProcessingActivityReportProps) {
    const [receiptDialog, setReceiptDialog] = useState<ProcessingActivityReportReceipt | undefined>(undefined);

    return (
        <>
            {props.showReportDialog && <ProcessingActivtyReportDialog setReceiptDialog={setReceiptDialog} {...props} />}
            {receiptDialog?.showDialog && <ProcessingActivityReportReceiptDialog receipt={receiptDialog} onDialogClose={() => setReceiptDialog(undefined)} />}
        </>
    );
}

export default ProcessingActivityReport;
